export default __webpack_public_path__ + "static/media/pd_gal_1.776a2ac9.png";